// extracted by mini-css-extract-plugin
export default {"root":"LayoutSingleColumn_root__A2vUK","banner":"LayoutSingleColumn_banner__U86+3","topbar":"LayoutSingleColumn_topbar__hJg2i","main":"LayoutSingleColumn_main__Nyvu9"};